var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M57.5,115A57.5,57.5,0,1,1,115,57.5,57.565,57.565,0,0,1,57.5,115Zm0-112.616A55.116,55.116,0,1,0,112.616,57.5,55.178,55.178,0,0,0,57.5,2.384Z","fill":"#e84a32","key":0}),React.createElement("path",{"d":"M0,113H2V0H0Z","transform":"translate(57 2)","fill":"#e84a32","key":1}),React.createElement("path",{"d":"M0,2H108V0H0Z","transform":"translate(4 41)","fill":"#e84a32","key":2}),React.createElement("path",{"d":"M83.456,74,0,1.818,1.546,0,85,72.184Z","transform":"translate(24 12)","fill":"#e84a32","key":3}),React.createElement("path",{"d":"M1.546,74,0,72.184,83.456,0,85,1.818Z","transform":"translate(8 12)","fill":"#e84a32","key":4})]);
}

LogoInline.defaultProps = {"width":"115","height":"115","viewBox":"0 0 115 115"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
